import { render, staticRenderFns } from "./addShortVideo.vue?vue&type=template&id=cc0a0c3c&scoped=true&"
import script from "./addShortVideo.vue?vue&type=script&lang=js&"
export * from "./addShortVideo.vue?vue&type=script&lang=js&"
import style0 from "./addShortVideo.vue?vue&type=style&index=0&id=cc0a0c3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0a0c3c",
  null
  
)

export default component.exports